import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import axios from 'axios';
import '../../../pages/admin/admin_assets/css/common.css';
import config from '../../../config/config.js';

function Tags() {
  const [category, setCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [editCategoryId, setEditCategoryId] = useState(null);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/get_tags.php`);
      const data = await response.json();
      if (data.success) {
        setCategories(data.categories);
      } else {
        toast.error(data.message || 'Failed to fetch tags.');
      }
    } catch (error) {
      toast.error('An error occurred while fetching tags.');
    } finally {
      setLoading(false);
    }
  };

  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };

  const handleSubmit = async () => {
    if (!category.trim()) {
      toast.error('Please enter a valid tag.');
      return;
    }

    try {
      const url = isEditing
        ? `${config.API_BASE_URL}/update_tag.php`
        : `${config.API_BASE_URL}/tags.php`;

      const payload = isEditing ? { id: editCategoryId, name: category } : { name: category };
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data.success) {
        toast.success(`Tag "${category}" ${isEditing ? 'updated' : 'added'} successfully!`);
        fetchCategories();
        setCategory('');
        setIsEditing(false);
        setEditCategoryId(null);
      } else {
        toast.error(data.message || 'Failed to save tag.');
      }
    } catch (error) {
      toast.error('An error occurred while saving the tag.');
    }
  };

  const handleEdit = (category) => {
    setIsEditing(true);
    setEditCategoryId(category.id);
    setCategory(category.name);
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/delete_tag.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id }),
      });

      const data = await response.json();
      if (data.success) {
        toast.success('Tag deleted successfully!');
        setCategories((prev) => prev.filter((cat) => cat.id !== id));
      } else {
        toast.error(data.message || 'Failed to delete tag.');
      }
    } catch (error) {
      toast.error('An error occurred while deleting the tag.');
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="category_input_wrapper mt-5">
          <div className="mb-3" style={{ width: '33%' }}>
            <h1 className="dashboard_heading">{isEditing ? 'Edit Tag' : 'Create Tag'}</h1>
            <input
              type="text"
              id="categoryInput"
              className="form-control"
              placeholder="Enter Tag Name"
              value={category}
              onChange={handleCategoryChange}
            />
          </div>
        </div>

        <Button onClick={handleSubmit} className="exportbutton">
          {isEditing ? 'Update' : 'Create'}
        </Button>
      </div>

      <div id="configtable" className="w-100 table-container">
        {loading ? (
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Tag Name</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {categories.length > 0 ? (
                categories.map((category, index) => {
                  const formattedDate = new Date(category.created_at).toLocaleDateString();
                  return (
                    <tr key={category.id || index}>
                      <td>{category.name}</td>
                      <td>{formattedDate}</td>
                      <td>
                        <div className="action_btn">
                          <div
                            style={{ marginRight: '20px', color: '#0d6efd', cursor: 'pointer' }}
                            onClick={() => handleEdit(category)}
                          >
                            Edit
                          </div>
                          <div
                            style={{ color: '#dc3545', cursor: 'pointer' }}
                            onClick={() => handleDelete(category.id)}
                          >
                            Delete
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="3">No tags available</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      <ToastContainer />
    </>
  );
}

export default Tags;
